import { useMutation, useQueryClient } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useDealership } from '../../../../store/zustand/dealershipStore'

type EditCustomerSourceManual = {
  customer_source_id: number
  data_provider_id: number
  customer_source: string
}
type EditCustomerSourceFTP = {
  customer_source_id: number
  data_provider_id: number
  customer_source: string
  config: Record<string, any>
  url?: string
  username?: string
  password?: string
  filename?: string
}

type EditCustomerSourceDealerVault = {
  customer_source_id: number
  data_provider_id: number
  customer_source: string
  mongoData: Record<string, any>
  _id: string
}

type CustomerSourceData =
  | EditCustomerSourceFTP
  | EditCustomerSourceDealerVault
  | EditCustomerSourceManual
export const useEditCustomerSourceByCustomerSourceId = () => {
  const dealership = useDealership()
  const queryClient = useQueryClient()
  return useMutation(
    ({ data }: { data: CustomerSourceData }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sources/${data.customer_source_id}`,
        method: 'PATCH',
        data: {
          data,
        },
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries('customerSources')
      },
    },
  )
}
